<div class="max-w-3xl mx-auto px-4 py-6 space-y-6">
  <div class="flex items-center justify-between">
    <p class="text-sm text-gray-600">{{ textService.get('qrcode.description') | async }}</p>
    <tt-button variant="primary" (clicked)="downloadAllImages()">
      {{ textService.get('qrcode.download') | async }}
    </tt-button>
  </div>

  @for (tableGroup of tableGroups; track tableGroup) {
    <div class="bg-white rounded-xl shadow-sm border border-gray-200">
      <div class="px-5 py-4 border-b border-gray-100">
        <h5 class="font-semibold text-gray-800">
          {{ textService.get('qrcode.qr-codes') | async }} {{ tableGroup.name }}
        </h5>
      </div>
      <div class="divide-y divide-gray-100">
        @for (table of tableGroup.tables; track table) {
          <div class="flex items-center justify-between px-5 py-3">
            <span class="text-sm text-gray-700">{{ table.id }}</span>
            <img
              class="h-16 w-16 cursor-pointer"
              [src]="table.qrCode"
              [alt]="table.id"
              (click)="downloadImage(table)"
            />
          </div>
        }
      </div>
    </div>
  }
</div>
